import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="site-header">
      <Link to="/" className="brand" aria-label="Apex Breath home">
        <img src="/apex_icon.jpeg" alt="Apex Breath icon" className="brand-icon" />
        <span className="brand-name">Apex Breath</span>
      </Link>
      <nav className="header-nav" aria-label="Primary">
        <Link to="/why-activity">Why Activity</Link>
        <Link to="/faq">FAQ</Link>
        <a href="https://www.merokeeventures.com" target="_blank" rel="noopener noreferrer">
          Contact
        </a>
      </nav>
      <button type="button" className="header-cta header-cta-disabled" disabled>
        Coming Soon
      </button>
    </header>
  );
}

export default Header;
